<template>
  <v-snackbar
    :timeout="time"
    :color="colorComputed"
    fixed
    top
    :right="!isMobile"
    :centered="isMobile"
    v-model="show"
    :class="!isMobile ? 'mr-5 mt-2' : 'mt-2'"
    transition="slide-y-transition"
  >
    <div class="d-flex align-center">
      <v-icon left>
        {{ typeComputed }}
      </v-icon>
      <div>
        {{ msg }}
      </div>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn color="yellow" text v-bind="attrs" @click="show = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      msg: null,
      type: null,
      time: 5000,
    };
  },

  watch: {
    type(v) {
      if (v == "kadaboleh") {
        this.time = 10000;
      } else {
        this.time = 5000;
      }
    },
  },

  computed: {
    colorComputed() {
      return this.type == "create"
        ? "success"
        : this.type == "update"
        ? "primary"
        : this.type == "kadaboleh"
        ? "red"
        : "orange";
    },

    typeComputed() {
      return this.type == "create"
        ? "mdi-check-circle"
        : this.type == "update"
        ? "mdi-autorenew"
        : this.type == "kadaboleh"
        ? "mdi-link-variant-remove"
        : "mdi-delete";
    },

    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
  },
  watch: {
    show(v) {
      if (!v) {
        this.$store.commit("UNSET_NOTIF");
      }
    },
  },

  methods: {
    tes() {
      let cok = {
        msg: "wow",
        type: "create",
      };
      this.$store.commit("SET_NOTIF", cok);
    },
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SET_NOTIF") {
        this.msg = state.notif.msg;
        this.type = state.notif.type;
        this.show = true;
      }
    });
  },
};
</script>

<style>
</style>